import { render, staticRenderFns } from "./MailDocCanvas.vue?vue&type=template&id=3f3ad407&scoped=true&"
import script from "./MailDocCanvas.vue?vue&type=script&lang=js&"
export * from "./MailDocCanvas.vue?vue&type=script&lang=js&"
import style0 from "./MailDocCanvas.vue?vue&type=style&index=0&id=3f3ad407&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3ad407",
  null
  
)

export default component.exports